import { Button } from '@mui/material';
import { useSegment } from 'common/hooks/segment';
import * as React from 'react';
import { usePerDiemParams } from '../../params';
import { LegacyPerDiemDownloadModal } from './LegacyPerDiemDownloadModal';
import { DateSearchSpec } from '../selectors';

interface Props {
  searchSpec: DateSearchSpec | null;
}

export const FinalizeReport: React.FC<Props> = (props) => {
  const { searchSpec } = props;
  const [showModal, setShowModal] = React.useState(false);
  const { track } = useSegment();

  const { searchParams } = usePerDiemParams();

  const handleClick = React.useCallback(() => {
    if (!searchSpec) {
      return;
    }

    setShowModal(true);

    track(
      'Finalize Report Button Clicked',
      {
        radioButton: searchParams.mode,
        shippingLine: searchParams.shippingLine,
        containerType: searchParams.container,
        startDate:
          searchSpec.mode === 'date-range'
            ? searchSpec.startDate.format()
            : searchSpec.date.format(),
        endDate: searchSpec.mode === 'date-range' ? searchSpec.endDate.format() : '',
        time: searchSpec.mode === 'specific-date' ? searchSpec.time : '',
        numberOfDays:
          searchSpec.mode === 'date-range'
            ? searchSpec.endDate.diff(searchSpec.startDate, 'days')
            : '',
      },
      { includeUser: true }
    );
  }, [searchSpec, searchParams, track]);

  return (
    <div>
      <LegacyPerDiemDownloadModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        search={searchSpec}
      />
      <Button
        variant="contained"
        color="secondary"
        disabled={!searchSpec}
        onClick={handleClick}
        className="rounded-lg"
        sx={{
          minHeight: 58,
          minWidth: 180,
          width: 224,
          fontSize: 16,
          letterSpacing: 0,
        }}
      >
        Send Email Report
      </Button>
    </div>
  );
};
